<template>
    <v-tooltip color="primary" top>
        <template v-slot:activator="{ on }">
        <v-icon v-on="on" :color="color">{{priorityIcon}}</v-icon>
        </template>
        <span>
            Sampling priority {{value}}
        </span>
    </v-tooltip>
</template>

<script>
    export default {

        props: {
            value: {
                type: Number,
                required: true
            }
        },

        computed: {

            color() {
                let distance = (this.value - 5) * 20;

                let red = 127;
                let green = 127;
                let blue = 127;

                if (distance > 0) {
                    red -= distance;
                    green += distance;
                    blue -= distance;
                }

                if (distance < 0) {
                    distance = Math.abs(distance);
                    red += distance;
                    green -= distance;
                    blue -= distance;
                }

                return 'rgba(' + red + ',' + green + ',' + blue + ', 1)';
            },

            priorityIcon() {

                if (this.value === 5) return "mdi-circle-medium";
                if (this.value >= 9) return "mdi-chevron-triple-up";
                if (this.value >= 7) return "mdi-chevron-double-up";
                if (this.value > 5) return "mdi-chevron-up";
                if (this.value === 5) return "mdi-circle-small";
                if (this.value <= 1) return "mdi-chevron-triple-down";
                if (this.value <= 3) return "mdi-chevron-double-down";
                if (this.value < 5) return "mdi-chevron-down";
            }
        }
    }
</script>
